import React from 'react'
import { CenteredErrorMessage } from '@/components_deprecated/CenteredErrorMessage/CenteredErrorMessage'
import { useUser } from '@/utils/hooks'
import { useTranslate } from '@ur-solutions/react-hooks'

export const SuperuserRequired: React.JSX.CFC = ({ children }) => {
  const user = useUser()
  const translations = useTranslate({
    notPermitted: 'error.not-permitted-to-view',
  })

  if (!user.isSuperuser) {
    return <CenteredErrorMessage message={translations.notPermitted} />
  }

  return <>{children}</>
}
